import axios from 'axios';

// 홈 API
export const ApiClient = axios.create({
  // baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  withCredentials: true,
  responseType: 'json',
});
